import React, { RefObject } from 'react';
import { VideoPlayerCamera } from 'types/videoPlayerTypes';
import useCameraDetailsOverlayStyles from 'components/CameraDetailsOverlay/styles';
import { Typography, Tooltip } from '@mui/material';

export interface LocationLabelProps {
  data: VideoPlayerCamera;
  buttonsWrapperRef: RefObject<HTMLDivElement>;
}
const LocationLabel: React.FunctionComponent<LocationLabelProps> = (props) => {
  const classes = useCameraDetailsOverlayStyles();
  const { data, buttonsWrapperRef } = props;

  return (
    <div className={classes.locationLabels}>
      {data?.referencePoint !== undefined && data?.referencePoint !== null && (
        <Typography variant='body1' className={classes.referenceLabel}>
          {data.referencePoint}
        </Typography>
      )}
      {!!data?.locationDescription && (
        <Tooltip
          title={data.locationDescription}
          PopperProps={{ container: buttonsWrapperRef.current }}
        >
          <Typography
            variant='body1'
            textOverflow='ellipsis'
            overflow='hidden'
            noWrap
            className={classes.locationDescriptionLabel}
          >
            {data.locationDescription}
          </Typography>
        </Tooltip>
      )}
    </div>
  );
};

export default LocationLabel;
